export const ProgressBarCalculateCurrentProgress = (
    completed: number,
    total: number
): number => {
    if (total === 0) return 0;
    const progress = Math.ceil((completed / total) * 100);
    return progress;
};
